import useSWR from 'swr';
import { FetchResult, Presentation } from '../entities';

type Result = FetchResult & { presentation: Presentation };

export function usePresentation(id: string): Result {
  const { data, error, mutate } = useSWR(`/presentations/edit/${id}`);

  return {
    presentation: data?.data,
    isLoading: !error && !data,
    isError: error,
    mutate,
  };
}
